











































import {Component, Vue} from 'vue-property-decorator';
import {
  Getter,
  Action,
} from 'vuex-class';

@Component
export default class SignIn extends Vue {
  private loading: boolean = false;
  private user: any = {
    username: null,
    password: null,
  };

  @Getter('auth/username') private username!: string;
  @Action('auth/signIn') private signIn!: (arg0: any) => Promise<any>;

  public Login(e: Event) {
    e.preventDefault();
    this.loading = true;
    this.signIn(this.user)
      .then((res: any) => {
        this.loading = false;
        if (res && res.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.$router.push({ name: 'CompleteNewPassword' });
        } else {
          this.$router.push({ name: 'Dashboard' });
        }
      });
  }

  public mounted() {
    if (this.username) {
      this.user.username = this.username;
    }
  }
}
